import ApiService from '../apiservice'

export default class FaseTarefaService extends ApiService {
  constructor() {
    super('/faseTarefa')
  }

  cadastrar(fase) {
    return this.post('/',fase);
  }

  listar(empresa) {
    return this.get(`/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/porCodigo/${codigo}`);
  }

  alterar(fase) {
    return this.put('/',fase);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}